"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOnboardingThirdPartiesResponseAllOfToJSON = exports.GetOnboardingThirdPartiesResponseAllOfFromJSONTyped = exports.GetOnboardingThirdPartiesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetOnboardingThirdPartiesResponseAllOfFromJSON(json) {
    return GetOnboardingThirdPartiesResponseAllOfFromJSONTyped(json, false);
}
exports.GetOnboardingThirdPartiesResponseAllOfFromJSON = GetOnboardingThirdPartiesResponseAllOfFromJSON;
function GetOnboardingThirdPartiesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'onboardingThirdParties': (json['onboardingThirdParties'].map(_1.OnboardingThirdPartyFromJSON)),
    };
}
exports.GetOnboardingThirdPartiesResponseAllOfFromJSONTyped = GetOnboardingThirdPartiesResponseAllOfFromJSONTyped;
function GetOnboardingThirdPartiesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'onboardingThirdParties': (value.onboardingThirdParties.map(_1.OnboardingThirdPartyToJSON)),
    };
}
exports.GetOnboardingThirdPartiesResponseAllOfToJSON = GetOnboardingThirdPartiesResponseAllOfToJSON;
